module.exports = __webpack_public_path__ + "static/img/servicesbg6.72a933c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/servicesbg6.jpg
// module id = PjgY
// module chunks = 1